import { CircularProgress } from "@mui/material";
import intl from "react-intl-universal";
import { getAccountTypeLabel } from "../../../Constants/accountTypes";

type SelectedAccountBalanceProps = {
  accountType?: string;
  accountLabel?: string;
  formattedBalance?: string;
  loading?: boolean;
  compact?: boolean;
  showAccountName?: boolean;
  hideLabel?: boolean;
  showLimit?: boolean;
  formattedAvailable?: string;
  formattedLimit?: string;
  formattedRemainingLimit?: string;
  caption?: string;
};

export const SelectedAccountBalance = ({
  accountType,
  accountLabel,
  formattedBalance,
  loading = false,
  compact = false,
  showAccountName = true,
  hideLabel = false,
  showLimit = false,
  formattedAvailable = formattedBalance,
  formattedLimit,
  formattedRemainingLimit,
  caption = "",
}: SelectedAccountBalanceProps) => {
  const label = accountLabel || getAccountTypeLabel(accountType);
  const captionLimit = formattedRemainingLimit || formattedLimit;
  const resolvedCaption =
    caption
    || (showLimit && formattedAvailable && captionLimit
      ? intl.get("pix.transfer.spendableCaption", {
          available: formattedAvailable,
          limit: captionLimit,
        })
      : null);

  return (
    <div
      className={`rounded-xl border border-[#e7a73f]/30 bg-brand-cream/50 px-4 ${
        compact ? "py-2.5" : "py-3"
      }`}
    >
      {!hideLabel && (
        <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
          Saldo disponível
          {showAccountName ? ` · ${label}` : ""}
        </p>
      )}
      <div className={`flex min-h-[28px] items-center ${hideLabel ? "" : "mt-0.5"}`}>
        {loading ? (
          <CircularProgress size={18} sx={{ color: "#e7a73f" }} />
        ) : (
          <p className={`font-bold text-brand-dark ${compact ? "text-lg" : "text-xl"}`}>
            {formattedBalance}
          </p>
        )}
      </div>
      {!loading && resolvedCaption ? (
        <p className="mt-0.5 text-xs text-gray-500">{resolvedCaption}</p>
      ) : null}
    </div>
  );
};
